import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';

import { LayoutModule } from './layout/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { ModalComponent } from './modal/modal.component';
import { ImportPropertyComponent } from './components/import-property/import-property.component';
import { AlertComponent } from './components/alert/alert.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FileUploadModule } from 'ng2-file-upload';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms';
import { AutocompleteModule } from '@app/components/autocomplete/autocomplete.module';
import { FocusedDirective } from '@app/directives/focus-list.directive';
import { SidepanelModule } from '@app/sidepanel/sidepanel.module';
import { SidepanelComponent } from '@app/sidepanel/sidepanel.component';
import { AddjobComponent } from '@app/property/addjob/addjob.component';
import { FileDirective } from '@app/directives/file.directive';
import { FileDropDirective } from '@app/directives/file-drop.directive';
import { LogoutComponent } from './logout/logout.component';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateService} from '@ngx-translate/core';
import { ResetPwdComponent } from './reset-pwd/reset-pwd.component';
import { ResetPwdViewResolver } from '@app/resolvers/resetpwd.view.resolver.ts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbModal, NgbActiveModal,  NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import { ErrorComponent } from './error/error.component';
import { DeactivateGuard  } from '@app/guard';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ImportPropertyComponent,
    AlertComponent,
    LogoutComponent,
    ResetPwdComponent,
    ModalComponent,
    ErrorComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    LayoutModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BsDatepickerModule.forRoot(),
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteModule,
    SidepanelModule,
    NgbModule,
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    AutocompleteModule,
    SidepanelModule,
  ],
  providers: [
      { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
      TranslateService,
      ResetPwdViewResolver,
      NgbModal,
      NgbActiveModal,
      NgbModalConfig,
      DeactivateGuard,
  ],
  bootstrap: [AppComponent],
  entryComponents: [ModalComponent]
})
export class AppModule { }
